export default "__VITE_ASSET__yLhncQGA__"